import Vue from "vue";
import { Module } from "vuex";
import { RootState } from "@/stores";
import {
  FeatureToggles,
  getToggles,
  ToggleState,
} from "@/utils/featureToggles";

export interface ConfigState {
  serviceUrl: string;
  featureToggles: ToggleState;
  currentHomeTab: string | null;
}

const getInitialState = (): ConfigState => {
  return {
    serviceUrl: "",
    featureToggles: {} as ToggleState,
    currentHomeTab: null,
  };
};

const initialState: ConfigState = getInitialState();

const config: Module<ConfigState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: {
    setConfig(state: ConfigState, config: any) {
      Vue.set(state, "serviceUrl", config["adminServiceUrl"]);
      Vue.set(state, "featureToggles", getToggles(config));
    },
    setCurrentHomeTab(state: ConfigState, payload: string) {
      state.currentHomeTab = payload;
    },
  },
  getters: {
    getToggle:
      (state: ConfigState) =>
      (key: FeatureToggles): boolean => {
        return state.featureToggles[key];
      },
    isJKTDashboard: () => {
      const jktHosts = ["asia-southeast2", "prd.asse2"];
      return jktHosts.some((host) => window.location.hostname.includes(host));
    },
  },
};

export default config;
